import type { Network } from "../types";

export const facebook: Network = {
  name: "Facebook",
  shareUrl: "https://www.facebook.com/sharer/sharer.php?u=[u]",
  icon: "/media/images/social-share-facebook.png",
  color: "#0866FF",
};
